import { SectionEnum } from '~/constants/enums/listingEnums';
import { formatNumber } from '~/lib';
import { useTranslation } from 'react-i18next';

const ListingPrice = ({
  price,
  area,
  section = 'for-sale',
  showPricePerMeter = false,
}: {
  price: number;
  area: number;
  section: string;
  showPricePerMeter?: boolean;
}) => {
  const { t } = useTranslation('app');
  const hasPrice = price !== null && !isNaN(price) && price !== 0;
  const priceText = hasPrice
    ? `${formatNumber(price)}
    ${t('egp')}`
    : t('callForPrice');

  return (
    <div className="flex gap-x-0.5x">
      {hasPrice ? (
        <>
          <span className="text-title_4 text-black whitespace-nowrap">
            {priceText}
          </span>
          {section === SectionEnum.FORSALE && area && showPricePerMeter && (
            <span className="text-caption text-gray__dark_1 whitespace-nowrap">
              - {formatNumber(Math.floor(price / area))} {t('pricePerMeter')}
            </span>
          )}
        </>
      ) : (
        <span className="text-title_4 text-black whitespace-nowrap">
          {priceText}
        </span>
      )}
    </div>
  );
};

export default ListingPrice;
